<template>
  <nx-renderless-search entity="content"
                        :sort="sort"
                        :filters="filters"
                        :limit="20"
                        ref="contents">
    <template slot-scope="{ items, loading, hasMorePages, loadMore }">
      <div>
      <template v-if="items.length > 0">
        <nx-list :items="toListItems(items)" bag selectable v-on="$listeners" hide-chips>
          <template #item-actions="props">
            <nx-bag-item-actions :item="props.item"
                                 :deletable="deletableItems"
                                 preview
                                 metadata
                                 editable
                                 v-on="$listeners" />
          </template>
        </nx-list>

        <v-btn v-if="hasMorePages"
               :loading="loading"
               @click="loadMore"
               color="secondary"
               block
               flat>
          {{ $t('message.common.loadMore') }}
        </v-btn>
      </template>

      <nx-bag-empty-item v-else-if="!loading" :text="$t('message.bag.noContent')"></nx-bag-empty-item>
      </div>

    </template>
  </nx-renderless-search>
</template>

<script>
import { makeFormatter } from '@/modules/list/config';
import NxRenderlessSearch from '@/modules/searcher/RenderlessSearcher';
import NxBagEmptyItem from '../common/BagEmptyItem';
import NxBagItemActions from '../common/BagListItemActions';
import NxList from '@/components/list/List';

export default {
  components: {
    NxList,
    NxRenderlessSearch,
    NxBagEmptyItem,
    NxBagItemActions,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
    sort: {
      type: Object,
    },
    deletableItems: {
      type: Boolean,
    },
  },
  methods: {
    refresh() {
      this.$refs.contents.refresh();
    },
    toListItems(items) {
      // https://github.com/vuejs/vue/issues/2000#issuecomment-527146280
      return Object.freeze(items.map((item) => {
        const { entity } = item;
        if (entity.list) {
          return entity.list;
        }
        return makeFormatter('content')(entity);
      }));
    },
  },
};
</script>
